import Vue from 'vue';
import accounting from 'accounting';

Vue.filter('currency', (...para) => {
    let value = para[0];
    let symbol = (para[1] && para[1].hasOwnProperty('symbol')) ? para[1].symbol : "£";
    let precision = (para[1] && para[1].hasOwnProperty('precision')) ? para[1].precision : 0;

    return accounting.formatMoney(value, symbol, precision)
});



// WEBPACK FOOTER //
// ./src/filters.js